import React from 'react';
import { Box, Container, Grid, Paper, Typography } from '@mui/material';
import Seo from '../components/Seo';

const imageBaseUrl = (process.env.REACT_APP_API_URL || 'https://apigrosvenor.clouddevnest.com/api').replace('/api', '');
const aboutImageUrl = `${imageBaseUrl}/uploads/logos/aboutus.jpg`;

const AboutUs = () => {
  return (
    <Box sx={{ backgroundColor: '#f8fafc', minHeight: '100vh', pt: { xs: 12, md: 14 }, pb: 8 }}>
      <Seo
        title="About Us"
        description="Learn more about Grosvenor Plymouth, a charming Victorian hotel near Plymouth Hoe offering warm hospitality and comfortable stays."
        keywords="About Grosvenor Plymouth, Plymouth hotel, Victorian hotel, The Hoe Plymouth, hotel accommodation"
        author="Grosvenor Plymouth"
      />

      <Container maxWidth="xl">
        <Paper
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 4,
            boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
            overflow: 'hidden'
          }}
        >
          <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="h2"
                sx={{
                  fontFamily: 'Playfair Display',
                  fontWeight: 700,
                  color: 'primary.main',
                  mb: 2,
                  fontSize: { xs: '2.1rem', md: '3rem' }
                }}
              >
                About Us
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: '#111827',
                  mb: 3,
                  fontSize: { xs: '1.3rem', md: '1.6rem' }
                }}
              >
                Who we are
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: '#4b5563',
                  lineHeight: 1.95,
                  fontSize: { xs: '1rem', md: '1.05rem' },
                  textAlign: 'justify'
                }}
              >
                Originally built in 1879 this beautiful Victorian property was formerly used as a private residential dwelling before being transformed into the Grosvenor Hotel in 1990. Currently operating on a bed and breakfast basis, a full locally sourced and freshly cooked breakfast is included in your overnight price. Our two guest lounges and TV room are friendly and inviting places to relax outside of your room and host a fully stocked licensed bar, a selection of freshly ground coffees and bar snacks. We have good quality WiFi with unlimited wireless fibre broadband throughout all guest rooms and communal areas. Being situated on the Plymouth Hoe, just 50 yards from the stunning views of the Plymouth Sound and less than 200 yards from the modern and bustling city centre, the Grosvenor Plymouth is the perfect residence for a wide variety of visitors. Whether for work, study, a holiday, visiting family or simply a well earned break, the personal touch and comforts of the hotel will certainly ensure an enjoyable stay.
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={aboutImageUrl}
                alt="About Grosvenor Plymouth"
                sx={{
                  width: '100%',
                  height: { xs: 320, md: 500 },
                  objectFit: 'cover',
                  borderRadius: 4,
                  boxShadow: '0 16px 40px rgba(0, 0, 0, 0.18)'
                }}
              />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default AboutUs;
